export const CONTENTS_ATTRIBUTE_ANOTHER = {
  website: {
    type: "website",
    attribute: { url: "" },
  },
  "youtube-live": {
    type: "youtube-live",
    attribute: { path: "" },
  },
  "video-streaming": {
    type: "video-streaming",
    attribute: { url: "" },
  },
  "running-text": {
    type: "running-text",
    attribute: {
      text: "text",
      direction: "left",
      fontSize: "16px",
      color: "#ffffff",
      speed: 10,
      fontFamily: "IBM Plex Sans Thai",
      backgroundColor: "#000000",
    },
  },
};
